import React from 'react'
import HeaderTitle from '../../../components/HeaderTitle'
import { useForm } from 'react-hook-form'
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from 'axios'
import swal from 'sweetalert'
import BackButton from '../../../components/BackButton';
function CreateCar() {
    const createCarForm = useForm()
    const navigate = useNavigate()

    const { token } = useSelector((state) => state.auth)

    const createCarSubmit = (data) => {
        console.log(data)
        axios.post(`${process.env.REACT_APP_SERVICE_URL}/vehicle`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                swal('Başarılı', 'Araç başarıyla eklendi.', 'success')
                navigate('/cars')
            })
            .catch((error) => {
                console.error(error)
                swal('Hata', 'Araç eklenirken bir hata oluştu.', 'error')
            })
    }
    return (
        <div className='container-fluid'>
            <HeaderTitle title='Araç Ekle' description='Araçlarınızı buradan ekleyebilirsiniz.' />

            <div className='row'>
                <div className='col-md'>
                    <div className='card'>
                        <div className='card-body'>
                            <BackButton />
                            <form className='my-3' onSubmit={createCarForm.handleSubmit(createCarSubmit)}>
                                <div className='mb-3'>
                                    <label htmlFor='trackingId' className='form-label'>Takip Kodu</label>
                                    <input type='text' className='form-control' id='trackingId' {...createCarForm.register('trackingId')} />
                                </div>
                                <div className='mb-3'>
                                    <label htmlFor='plate' className='form-label'>Plaka</label>
                                    <input type='text' className='form-control' id='plate' {...createCarForm.register('plate')} />
                                </div>
                                <div>
                                    <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Kaydet</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateCar